<template>
  <div class="project-detail-wrap" ref="projectList">
    <Header />
    <div class="content-wrap">
      <BigTitle :text="info.name" :bg-text="info.name" :english="info.english" :is-bg="true"/>
      <div class="detail-box">
        <div class="title">{{ info.title1}}</div>
        <div class="desc-box" v-if="info.id === '101'">
          <img v-if="info.image" :src="info.image" alt="" @click="showImagePreview(info.image)">
          <div class="letter">
            <div class="desc" v-for="(item, index) in info.desc" :key="index">
              {{ item }}
            </div>
            <div class="desc" v-for="item in info.engDesc" :key="item">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="title" v-if="info.imageList" style="margin-top: 0.16rem">{{ info.name }}( {{ info.english }} )</div>
        <div class="column-center" :class="{'mb': info.id !== '101'}" v-if="info.imageList">
          <span v-for="(item, index) in info.imageList" :key="index">
            <img :src="item" alt="" @click="showImagePreview(item)">
          </span>
        </div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Header from '@/views/mobile/components/Header'
import Bottom from '@/views/mobile/components/Bottom'
import BigTitle from './components/BgTitle'
import {projects} from '@/assets/project'
export default {
  name: "ProjectDetail",
  components: { Header, Bottom, BigTitle},
  data(){
    return{
      projects,
      id:0,
      name: '',
      image: '',
      english: '',
      info: {}
    }
  },
  mounted (){
    this.init()
  },
  methods: {
    init () {
      this.$refs.projectList.scrollTop = 0
      this.id = this.$route.query.id
      this.handleDetail()
    },
    handleDetail () {
      projects.map(item => {
        if (item.id === this.id) {
          this.info = item
        }
      })
    },
    showImagePreview(item) {
      const image = new Image();
      image.src = item;
      image.onload = () => {
        // 创建弹出层
        const previewContainer = document.createElement('div');
        previewContainer.style.position = 'fixed';
        previewContainer.style.top = 0;
        previewContainer.style.bottom = 0;
        previewContainer.style.left = 0;
        previewContainer.style.right = 0;
        previewContainer.style.backgroundColor = 'rgba(0,0,0,0.8)';
        previewContainer.style.display = 'flex';
        previewContainer.style.justifyContent = 'center';
        previewContainer.style.alignItems = 'center';
        document.body.appendChild(previewContainer);
        // 在弹出层中添加图片
        const previewImage = document.createElement('img');
        previewImage.src = item;
        previewImage.style.maxWidth = '100%';
        previewImage.style.maxHeight = '100%';
        previewContainer.appendChild(previewImage);
        // 点击弹出层，关闭预览
        previewContainer.addEventListener('click', () => {
          document.body.removeChild(previewContainer);
        });
      };
    }
  }
}
</script>

<style lang="less" scoped>
.project-detail-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  .content-wrap {
    width: 100%;
    .tag-box {
      color: #f56c6c;
      border: 1px dashed #f56c6c;
      font-size: 0.4rem;
      padding: 0.32rem;
      margin: 0.32rem;
    }
    .detail-box {
      width: calc(100% - 0.64rem);
      margin: 0.32rem;
      .title {
        padding: 0 0 0 0.16rem;
        border-left: 0.1rem solid #3a8ee6;
        font-size: 0.4rem;
        color: #3a8ee6;
        margin-bottom: 0.16rem;
      }
      .desc-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        img {
          margin-top: 0.16rem;
          width: 100%;
          height: 100%;
        }
        .letter {
          margin-top: 0.16rem;
          display: flex;
          flex-direction: column;
          flex: 1;
          font-size: 0.4rem;
        }
        .desc {
          margin-top: 0.16rem;
          display:flex;
          white-space: pre-wrap;
          text-indent: 2em;
        }
      }
    }
    .column-center {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: 5rem;
      }
    }
    .mb {
      margin-bottom: 2rem;
    }
  }
}
</style>
